import CustomBackButton from './CustomBackButton'
import CustomNavbar from 'components/users/CustomNavbar'
import { Container } from 'react-bootstrap'
import { NavigateOptions, useNavigate } from 'react-router-dom';

/**
 * custom props for the admin container component
 */
interface Props {
    /**
     * children component
    */
    children: JSX.Element;
    /**
     * maxWidth set if needed
     */
    customMaxWidth?: number;
    /**
     * the route that the back button should redirect to if not provided is set to the previous one
     */
    backRoute?: string;
    /**
     * the route that the back button should redirect to if not provided is set to the previous one
     */
    backRouteOptions?: NavigateOptions;
    /**
     * the route that the back button should redirect to if not provided is set to the previous one
     */
    customClass?: string;
}

/**
 * An admin route container with its back button and navBar
 */
export const AdminRouteContainer = ({
    children,
    customMaxWidth,
    backRoute,
    backRouteOptions,
    customClass
}: Props) => {
    const navigate = useNavigate();
    const maxWidth = customMaxWidth ? `${customMaxWidth}px` : undefined;

    /**
     * handles the back button click and returns to the previous route
     */
    const onBackButtonClick = () => {
        if (backRoute) {
            navigate(backRoute, backRouteOptions);
        } else {
            navigate(-1);
        }
    };

    return (
        <>
            <CustomBackButton
                onClick={onBackButtonClick}
            />
            <CustomNavbar />
            <Container style={{ maxWidth }} className={`d-flex flex-column px-4 px-md-5 ${customClass ?? "align-items-center"}`}>
                {
                    children
                }
            </ Container>
        </>
    )
}
